import { Loader2 } from "lucide-react";
import clsx from "clsx";

type Props = {
  className?: string;
  size?: "sm" | "md" | "lg";
};

const SIZE_CLASS = {
  sm: "h-5 w-5",
  md: "h-8 w-8",
  lg: "h-10 w-10",
} as const;

export function PatientV2CircularLoader({
  className,
  size = "md",
}: Props) {
  return (
    <div
      className={clsx(
        "flex w-full items-center justify-center p-8",
        className,
      )}
      role="status"
      aria-label="Loading"
    >
      <Loader2
        className={clsx(SIZE_CLASS[size], "animate-spin text-muted-foreground")}
        aria-hidden
      />
    </div>
  );
}

export function patientV2LoaderWrapper() {
  return <PatientV2CircularLoader />;
}
